// import { Link } from "react-router-dom";
// import { downloadReceipt, DownloadBulkReceipt } from "../../../services/Common";
// import { useState } from "react";
// import { Loader } from "../../utils";


// const SuccessPayment = ({ setOpenModal, lang, enPhrase, arPhrase, serviceid, isPaid, ppidValue, service, IsInvoice, selectedServiceIds }) => {
//   const [loading, setLoading] = useState(false);
//   console.log("selectedServiceIds", selectedServiceIds)

//   const triggerBlobDownload = (blob) => {
//     if (!blob) {
//       console.error("Failed to download file");
//       return;
//     }
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "Receipt.pdf";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   };


//   const getDownloadReceipt = () => {
//     setLoading(true)
//     downloadReceipt(service?.id).then(
//       (blob) => {
//         if (!blob) {
//           console.error("Failed to download file");
//           return;
//         }

//         const url = window.URL.createObjectURL(blob);

//         // Create a temporary link and trigger the download
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = "Receipt.pdf"; // You can extract filename from `content-disposition` if needed
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//         setLoading(false)
//       },
//       (err) => {
//         console.log("Fail Payment !!!!!", err);
//       }
//     );
//   };


//   const getDownloadBulkReceipt = () => {
//     setLoading(true);

//     // ✅ Extract the first valid database entry ID value from our filtered selection prop
//     const targetServiceId = selectedServiceIds;
//     console.log("Downloading receipt for service ID:", targetServiceId);

//     DownloadBulkReceipt(targetServiceId).then(
//       (blob) => {
//         triggerBlobDownload(blob);
//         setLoading(false);
//       },
//       (err) => {
//         console.log("Fail Bulk Payment Receipt Download Error:", err);
//         setLoading(false);
//       }
//     );
//   };

//   return (
//     <div className="w-full flex flex-col p-[16px] md:p-[32px] items-center">
//       <img
//         src={`${IsInvoice ? "/assets/img/invoices/check.svg" : "/assets/img/payment/success.svg"}`}
//         alt="success"
//         className="w-[40px] h-[40px] md:w-[42px] md:h-[42px] mb-[24px] md:mb-[32px]"
//       />
//       <p className="text-[18px] md:text-[24px]  text-[#2E7E31] font-bold text-center max-w-[296px] mb-[12px]">
//         {lang === "en"
//           ? enPhrase["lblPaymentCompleted"]
//           : arPhrase["lblPaymentCompleted"]}
//       </p>
//       <p className="mb-[16px]  font-Almarai text-[12px] leading-[24px] md:text-base text-[#666] text-center max-w-[296px]">
//         {lang === "en"
//           ? enPhrase["lblThanksForPaymenyt"]
//           : arPhrase["lblThanksForPaymenyt"]}
//       </p>
//       <p className="w-full text-[12px] md:text-[16px] leading-[24px] md:leading-[1.5rem]  text-[#010202] text-center font-Almarai font-bold max-w-[296px]">
//         {lang === "en"
//           ? enPhrase["lblPayDifferece"]
//           : arPhrase["lblPayDifferece"]}
//       </p>
//       <div className={`flex ${IsInvoice ? "flex-row" : " flex-col"} w-full mt-[32px] gap-[16px]`}>
//         <Link
//           to={`${IsInvoice ? "/invoices" : "/case-overview"}`}
//           className="flex flex-row justify-center items-center gap-2 w-full h-[48px] text-sm font-bold bg-[#B68A35] px-3 rounded-3 text-white "
//           onClick={() => setOpenModal(false)}
//         >
//           <span className="text-[14px]"> {lang === "en"
//             ? enPhrase["lblOk"]
//             : arPhrase["lblOk"]}</span>
//         </Link>
//         <button
//           className="flex flex-row justify-center items-center gap-2 w-full h-[48px] text-sm font-bold bg-[#B68A35] px-3 rounded-3 text-white "
//           onClick={IsInvoice ? getDownloadBulkReceipt : getDownloadReceipt}
//         >
//           <span className="text-[14px]"> {lang === "en"
//             ? enPhrase["lblDownloadReceipt"]
//             : arPhrase["lblDownloadReceipt"]}</span>
//           {loading ? <Loader color={"white"} /> : null}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SuccessPayment;

import { Link } from "react-router-dom";
import { downloadReceipt, DownloadBulkReceipt } from "../../../services/Common";
import { useState } from "react";
import { Loader } from "../../utils";

const SuccessPayment = ({
  setOpenModal,
  lang,
  enPhrase,
  arPhrase,
  service,
  IsInvoice,
  selectedServiceIds,
}) => {
  const [loading, setLoading] = useState(false);

  const triggerBlobDownload = (blob) => {
    if (!blob) {
      console.error("Failed to download file");
      return;
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "Receipt.pdf";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  };

  const getDownloadReceipt = () => {
    setLoading(true);

    downloadReceipt(service?.id).then(
      (blob) => {
        triggerBlobDownload(blob);
        setLoading(false);
      },
      (err) => {
        console.error("Fail Payment Receipt Download Error:", err);
        setLoading(false);
      }
    );
  };

  const getDownloadBulkReceipt = () => {
    setLoading(true);

    const callbackServiceId = window.sessionStorage.getItem(
      "temp_success_service_id"
    );

    console.log("Bulk receipt download values:", {
      callbackServiceId,
      selectedServiceIds,
      currentUrl: window.location.href,
    });

    if (!callbackServiceId) {
      console.error("Error: Missing callback service ID for bulk download", {
        selectedServiceIds,
        currentUrl: window.location.href,
      });

      setLoading(false);
      return;
    }

    DownloadBulkReceipt(callbackServiceId).then(
      (blob) => {
        triggerBlobDownload(blob);
        setLoading(false);
      },
      (err) => {
        console.error("Fail Bulk Payment Receipt Download Error:", err);
        setLoading(false);
      }
    );
  };

  const handleCloseModal = () => {
    window.sessionStorage.removeItem("temp_success_service_id");
    window.sessionStorage.removeItem("temp_success_invoice_id");

    setOpenModal(false);
  };

  return (
    <div className="w-full flex flex-col p-[16px] md:p-[32px] items-center">
      <img
        src={`${IsInvoice
          ? "/assets/img/invoices/check.svg"
          : "/assets/img/payment/success.svg"
          }`}
        alt="success"
        className="w-[40px] h-[40px] md:w-[42px] md:h-[42px] mb-[24px] md:mb-[32px]"
      />

      <p className="text-[18px] md:text-[24px] text-[#2E7E31] font-bold text-center max-w-[296px] mb-[12px]">
        {lang === "en"
          ? enPhrase["lblPaymentCompleted"]
          : arPhrase["lblPaymentCompleted"]}
      </p>

      <p className="mb-[16px] font-Almarai text-[12px] leading-[24px] md:text-base text-[#666] text-center max-w-[296px]">
        {lang === "en"
          ? enPhrase["lblThanksForPaymenyt"]
          : arPhrase["lblThanksForPaymenyt"]}
      </p>

      <p className={`w-full text-[12px] md:text-[16px] leading-[24px] md:leading-[1.5rem] text-[#010202] text-center font-Almarai font-normal md:font-bold ${IsInvoice ? "" : "max-w-[296px]"}`}>
        {lang === "en"
          ? enPhrase["lblPayDifferece"]
          : arPhrase["lblPayDifferece"]}
      </p>

      <div
        className={`flex ${IsInvoice ? "flex-row" : "flex-col"
          } w-full mt-[32px] gap-[16px]`}
      >
        <Link
          to={`${IsInvoice ? "/invoices" : "/case-overview"}`}
          className="flex flex-row justify-center items-center gap-2 w-full h-[48px] text-sm font-bold bg-[#B68A35] px-3 rounded-3 text-white"
          onClick={handleCloseModal}
        >
          <span className="text-[14px]">
            {lang === "en" ? enPhrase["lblOk"] : arPhrase["lblOk"]}
          </span>
        </Link>

        <button
          type="button"
          disabled={loading}
          className="flex flex-row justify-center items-center gap-2 w-full h-[48px] text-sm font-bold bg-[#B68A35] px-3 rounded-3 text-white disabled:opacity-70"
          onClick={IsInvoice ? getDownloadBulkReceipt : getDownloadReceipt}
        >
          <span className="text-[14px]">
            {lang === "en"
              ? enPhrase["lblDownloadReceipt"]
              : arPhrase["lblDownloadReceipt"]}
          </span>

          {loading ? <Loader color={"white"} /> : null}
        </button>
      </div>
    </div>
  );
};

export default SuccessPayment;